import React from "react";
import * as Icon from "react-bootstrap-icons";
import {NavLink, useNavigate} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import * as Utils from "../../inc/Utils";
import Select from 'react-select'
import {Config} from "../../Config";
import * as XLSX from 'xlsx';
import {confirmAlert} from "react-confirm-alert";
import utmTemplateProject from "../../download/UTMTemplate_Project_Template_Import.xlsx";
import utmTemplatePromotion from "../../download/UTMTemplate_Promotion_Template_Import.xlsx";
import utmTemplateSpecial from "../../download/UTMTemplate_Special_Template_Import.xlsx";
import utmTemplateMaterURL from "../../download/UTMTemplate_MasterURL_Template_Import.xlsx";
import moment from "moment-timezone";

export default function UtmGenerateImport() {
    const roles = new Role();
    let userId = roles.loginUserId;

    const navigate = useNavigate();

    let btnTextDefault = 'ดาวน์โหลดเทมเพลต';
    let btnTextLoading = 'กำลังดาวน์โหลด..';
    let [isLoading, setLoading] = React.useState(false);

    let btnTextUploadDefault = 'อัพโหลด';
    let btnTextUploading = 'กำลังอัพโหลด..';
    let [isUploading, setUploading] = React.useState(false);
    let [isUploaded, setUploaded] = React.useState(false);

    let btnTextImportDefault = 'นำเข้าระบบ & ดาวน์โหลด';
    let btnTextImporting = 'กำลังนำเข้า..';
    let [isImporting, setImporting] = React.useState(false);
    let [isPreviewing, setPreviewing] = React.useState(false);

    let [type, setType] = React.useState('');
    let [utmGroup, setUtmGroup] = React.useState(null);

    let [typeId, setTypeId] = React.useState(null);
    let [utmGroupId, setUtmGroupId] = React.useState(null);
    let [excelFile, setExcelFile] = React.useState(false);
    let [disableImport, setDisableImport] = React.useState(true);
    let [rebrandly, setRebrandly] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    let [previewParams, setPreviewParams] = React.useState('');
    let [langIds, setLangIds] = React.useState([]);
    let [projectTypeIds, setProjectTypeIds] = React.useState([]);
    let [buTypeIds, setBuTypeIds] = React.useState([]);
    let [sourceTypeAllIds, setSourceTypeAllIds] = React.useState([]);
    let [sourceTypeList, setSourceTypeList] = React.useState(null);
    let [hashtagList, setHashtagList] = React.useState('');
    let [hashtag, setHashtag] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const resType = await Utils.getType();
                setType(resType);
                const resGroup = await Utils.getGroup();
                setUtmGroup(resGroup);
                const resRebrandly = await Utils.getRebrandly();
                setRebrandly(resRebrandly);
                const resShortIO = await Utils.getShortIO();
                setShortIO(resShortIO);
                const sourceTypeList = await Utils.getUtmSourceType();
                setSourceTypeList(sourceTypeList);
                const resHashtag = await Utils.getHashtag();
                setHashtagList(resHashtag);

                //region language
                let langIds = [];
                const resLang = await Utils.getLanguage();
                if(resLang) {
                    for(let rs of resLang) {
                        let id = rs.id;
                        if(id) {
                            langIds.push(id);
                        }
                    }
                }
                setLangIds(langIds);
                //endregion

                //region project type
                let projectTypeIds = [];
                const resPJType = await Utils.getProjectType();
                if(resPJType) {
                    for(let rs of resPJType) {
                        let id = rs.id;
                        if(id) {
                            projectTypeIds.push(id);
                        }
                    }
                }
                setProjectTypeIds(projectTypeIds);
                //endregion

                //region bu type
                let buTypeIds = [];
                const resBuType = await Utils.getBuType();
                if(resBuType) {
                    for(let rs of resBuType) {
                        let id = rs.id;
                        if(id) {
                            buTypeIds.push(id);
                        }
                    }
                }
                setBuTypeIds(buTypeIds);
                //endregion

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getGroupView(groupId) {
        const response = await fetch(Config.url.API_URL +'/api/utmGroup/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: groupId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getProject(lang, project_type, campaign_date) {
        // + '&project_code=' +project_code + '&campaign_id=' + campaign_id
        const response = await fetch(Config.url.AP_API_URL + '/api/projects/campaigns?lang=' + lang+ '&project_type=' + project_type + '&campaign_date=' + campaign_date + '&limit=2000', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        //if(response.ok) {
            return response.json();
        //}
        //else {
        //    return response.json().then(err => Promise.reject(err));
        //}
    }

    async function getPromotion(lang, campaign_type, bu_type, campaign_date) {
        let url = Config.url.AP_API_URL + '/api/promotions/urls?lang=' + lang + '&campaign_type=' + campaign_type + '&bu_type=' + bu_type;

        // if(campaign_id) {
        //     url += '&campaign_id=' + campaign_id;
        // }
        if(campaign_date) {
            url += '&campaign_date=' + (campaign_date ? Utils.dateYMD(campaign_date, '-') : '');
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        //if(response.ok) {
            return response.json();
        //}
        //else {
        //    return response.json().then(err => Promise.reject(err));
        //}
    }

    const onChangeTypeId = (obj) => {
        setTypeId(obj);
        setExcelProjectPreview('');
        setExcelProjectPreviewError('');
        setExcelPromotionPreview('');
        setExcelPromotionPreviewError('');
        setExcelSpecialPreview('');
        setExcelSpecialPreviewError('');
        if(excelFile && excelFile.target) {
            excelFile.target.value = '';
        }
    };

    const onDownload = () => {
        if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else {
            let typeName = '';
            let data = {};
            let url = '';
            if(typeId.id === Utils.GENERATE_TYPE_PROJECT) {
                // typeName = 'Project';
                // data = [{
                //     "Lang": "",
                //     "Project Type": "",
                //     "Project Code": "",
                //     "Campaign ID": "",
                //     "Campaign Date": "",
                //     "Content ID": ""
                // }];
                url = utmTemplateProject;

            }
            else if(typeId.id === Utils.GENERATE_TYPE_PROMOTION) {
                // typeName = 'Promotion';
                // data = [{
                //     "Lang": "",
                //     "BU Type": "",
                //     "Campaign Type": "",
                //     "Campaign ID": "",
                //     "Campaign Date": "",
                //     "Content ID": ""
                // }];
                url = utmTemplatePromotion;
            }
            else if(typeId.id === Utils.GENERATE_TYPE_SPECIAL) {
                // typeName = 'Special';
                // data = [{
                //     "Lang": "",
                //     "Project Type": "",
                //     "Project Code": "",
                //     "Campaign ID": "",
                //     "Content ID": "",
                //     "Owner ID": ""
                // }];
                url = utmTemplateSpecial;
            }
            else if(typeId.id === Utils.GENERATE_TYPE_MASTER_URL) {
                // typeName = 'Master URL';
                // data = [{
                //     "Lang": "",
                //     "Project Type": "",
                //     "Project Code": "",
                //     "Campaign ID": "",
                //     "Master URL": "",
                //     "Content ID": "",
                //     "Owner ID": ""
                // }];
                url = utmTemplateMaterURL;
            }

            if(url) {
                const a = document.createElement('a');
                a.href = url;
                a.download = url.split('/').pop();
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            // const worksheet = XLSX.utils.json_to_sheet(data);
            // const workbook = XLSX.utils.book_new();
            // XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            // XLSX.writeFile(workbook, "UTMTemplate_" + typeName + "_" + Utils.getDate() + ".xlsx");
        }
    };

    let [data, setData] = React.useState('');
    let [showUtmPreview, setUtmPreview] = React.useState('');
    let [showExcelProjectPreview, setExcelProjectPreview] = React.useState('');
    let [showExcelProjectPreviewError, setExcelProjectPreviewError] = React.useState('');
    let [showExcelPromotionPreview, setExcelPromotionPreview] = React.useState('');
    let [showExcelPromotionPreviewError, setExcelPromotionPreviewError] = React.useState('');
    let [showExcelSpecialPreview, setExcelSpecialPreview] = React.useState('');
    let [showExcelSpecialPreviewError, setExcelSpecialPreviewError] = React.useState('');
    let [showExcelMasterURLPreview, setExcelMasterURLPreview] = React.useState('');
    let [showExcelMasterURLPreviewError, setExcelMasterURLPreviewError] = React.useState('');
    let [requireContentId, setRequireContentId] = React.useState(false);
    let [requireOwnerId, setRequireOwnerId] = React.useState(false);
    let [requireCampaignId, setRequireCampaignId] = React.useState(false);
    let [requireProjectId, setRequireProjectId] = React.useState(false);

    const onChangeHashtag = (obj) => {
        setHashtag(obj);
    };

    const onChangeUtmGroupId = async (obj) => {
        setUtmGroupId(obj);
        setUtmPreview('');
        setPreviewParams('');

        if(obj && obj.id) {
            setPreviewing(true);
            const data = await getGroupView(obj.id);
            setData(data);

            let showResult = [];
            let showPreview = [];
            let sourceTypeAllIdsTmp = [];
            if(data.groupItem) {
                for(let item of data.groupItem) {
                    let utmId = item.id;
                    let utmName = item.name;
                    let utmGroupId = item.utmGroupId;
                    const resView = await Utils.getGroupItemView(utmId);
                    if(resView) {
                        let templateId = resView.group.utmTemplateId;
                        let itemSource = resView.itemSource;
                        if(templateId) {

                            const resSource = await Utils.getTemplateSourceById(templateId);
                            const resUtm = await Utils.getUtmByIds(resSource);

                            //set all id
                            let sourceTypeIdsParam = [];
                            if(resUtm) {
                                for(let row of resUtm) {
                                    for(let rs of resSource) {
                                        let sourceType = rs.source.sourceType;
                                        if(rs.source && rs.utmId === row.id) {
                                            let inputType = rs.source.inputType;
                                            if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                                sourceTypeIdsParam.push('x:CID' +rs.source.id);
                                                setRequireContentId(true);
                                            }
                                            else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                                sourceTypeIdsParam.push('x:OID' +rs.source.id);
                                                setRequireOwnerId(true);
                                            }
                                            else if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                                                sourceTypeIdsParam.push('x:CP' + rs.source.id);
                                                setRequireCampaignId(true);
                                            }
                                            else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                                                sourceTypeIdsParam.push('x:CN' + rs.source.id);
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                                sourceTypeIdsParam.push('x:PJI' + rs.source.id);
                                                setRequireProjectId(true);
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                                sourceTypeIdsParam.push('x:PJN' + rs.source.id);
                                            }
                                            else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                                sourceTypeIdsParam.push('x:PJS' + rs.source.id);
                                            }
                                            else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                                sourceTypeIdsParam.push('x:PMS' + rs.source.id);
                                            }
                                            else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                                sourceTypeIdsParam.push('x:LINEOA' + rs.source.id);
                                            }
                                            else {
                                                let find = sourceType.find(rs => {
                                                    return itemSource.find(it => {
                                                        if(it.utmSourceTypeId === rs.id) {
                                                            return it;
                                                        }
                                                    });
                                                });
                                                if(find && find.id) {
                                                    sourceTypeIdsParam.push(find.id);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            sourceTypeAllIdsTmp.push({
                                id: utmId,
                                name: utmName,
                                utmGroupId: utmGroupId,
                                utmTemplateId: templateId,
                                params: sourceTypeIdsParam
                            });

                            let params = await Utils.generateParams({}, sourceTypeIdsParam);
                            showPreview.push({
                                id: item.id,
                                name: item.name,
                                params : params
                            });
                        }
                    }
                }
            }
            setUtmPreview(showResult);
            setPreviewParams(showPreview);
            setSourceTypeAllIds(sourceTypeAllIdsTmp);
            setPreviewing(false);
        }
    };

    const onSelectFile = (e) => {
      setExcelFile(e);
    };

    const onUpload = async () => {
        if(excelFile && excelFile.target.value) {
            if(!typeId) {
                toast.error("กรุณาระบุ Type");
            }
            else if(!utmGroupId) {
                toast.error("กรุณาระบุ Group");
            }
            else if(!showUtmPreview) {
                toast.error("ไม่พบ Group URL");
            }
            else if(!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);
                setExcelProjectPreview('');
                setExcelPromotionPreview('');
                setExcelSpecialPreview('');

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, { type: "binary" });
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });

                    if(data) {
                        let row = data.split('\n');
                        //Check Header
                        let header = row[0];
                        if(typeId.id === Utils.GENERATE_TYPE_PROJECT) {
                            let cols = header.split(',');
                            if(cols[0] !== 'Lang') {
                                setUploading(false);
                                toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                                return;
                            }
                            else if(cols[1] !== 'Project Type') {
                                setUploading(false);
                                toast.error("Column 2 : ต้องเป็น(ชื่อ) Project Type");
                                return;
                            }
                            else if(cols[2] !== 'Project Code') {
                                setUploading(false);
                                toast.error("Column 3 : ต้องเป็น(ชื่อ) Project Code");
                                return;
                            }
                            else if(cols[3] !== 'Campaign ID') {
                                setUploading(false);
                                toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                                return;
                            }
                            else if(cols[4] !== 'Campaign Date') {
                                setUploading(false);
                                toast.error("Column 5 : ต้องเป็น(ชื่อ) Campaign Date");
                                return;
                            }
                            else if(cols[5] !== 'Content ID') {
                                setUploading(false);
                                toast.error("Column 6 : ต้องเป็น(ชื่อ) Content ID");
                                //จำเป็นต้องใส่มา ถึงจะไม่มีข้อมูลก็ตาม
                                return;
                            }
                            else if(cols[6] !== 'Owner ID') {
                                setUploading(false);
                                toast.error("Column 7 : ต้องเป็น(ชื่อ) Owner ID");
                                //จำเป็นต้องใส่มา ถึงจะไม่มีข้อมูลก็ตาม
                                return;
                            }

                            if(row.length > 0) {
                                let message = [];
                                let statusAll = [];
                                let projectList = [];
                                let projectListError = [];

                                let contentIdArr = [];
                                if(requireContentId) {
                                    const contentIdList = await Utils.getContentId({agencyId: roles.agencyId});
                                    for(let rs of contentIdList) {
                                        contentIdArr.push(rs.contentId);
                                    }
                                }

                                for(let i=1;i<row.length;i++) {
                                    let status = 0;
                                    let cols = row[i].split(',');
                                    let colLang = cols[0].toString().trim();
                                    let colProjectType = cols[1].toString().trim();
                                    let colProjectCode = cols[2].toString().trim();
                                    let colCampaignId = cols[3].toString().trim();
                                    let colCampaignDate = Utils.dateFromExcel(cols[4].toString().trim());
                                    let colContentId = cols[5].toString().trim();
                                    let colOwnerId = cols[6].toString().trim();
                                    let showOwnerId = cols[6].toString().trim();
                                    let ownerRow = null;
                                    let statusOwnerId = true;

                                    if(requireOwnerId) {
                                        if(colOwnerId) {
                                            let ow = colOwnerId.split(':');
                                            ownerRow = await Utils.getOwnerViewByCode(ow[0]);
                                            colOwnerId = 'WID:' + ownerRow.id;
                                            if(!ownerRow.id) {
                                                status = 2;
                                                statusOwnerId = false;
                                            }
                                        }
                                        else {
                                            status = 2;
                                            statusOwnerId = false;
                                        }
                                    }

                                    if(colLang && colProjectType && colProjectCode) {
                                        let statusContentId = true;
                                        if(requireContentId) {
                                            if(contentIdArr && colContentId) {
                                                if(!contentIdArr.includes(colContentId)) {
                                                    status = 2;
                                                    statusContentId = false;
                                                }
                                                else {
                                                    statusContentId = true;
                                                }
                                            }
                                            else {
                                                status = 2;
                                                statusContentId = false;
                                            }
                                        }

                                        let statusLang = true;
                                        if(langIds && !langIds.includes(colLang)) {
                                            status = 2;
                                            statusLang = false;
                                            message.push('Invalid Lang');
                                        }
                                        else {
                                            statusLang = true;
                                        }

                                        let statusProjectType = true;
                                        if(projectTypeIds && !projectTypeIds.includes(colProjectType)) {
                                            status = 2;
                                            statusProjectType = false;
                                            message.push('Invalid Project Type');
                                        }
                                        else {
                                            statusProjectType = true;
                                        }

                                        let statusProjectCode = true;
                                        if(requireProjectId && !colProjectCode) {
                                            statusProjectCode = false;
                                            status = 2;
                                        }

                                        let statusCampaignId = true;
                                        if(requireCampaignId && !colCampaignId) {
                                            statusCampaignId = false;
                                            status = 2;
                                        }

                                        let statusCampaignDate = true;
                                        let url = '';
                                        let projectId = '';
                                        let projectSlug = '';
                                        let projectTypeSlug = '';
                                        let campaignName = '';
                                        let projectCodeArr = [];
                                        let campaignIdArr = [];

                                        if(!colCampaignDate) {
                                            status = 2;
                                            statusCampaignDate = false;
                                            message.push('Invalid campaign date');
                                        }
                                        else if(statusLang && statusProjectType && statusProjectCode && statusCampaignId && statusContentId && statusOwnerId) {
                                            status = 2;
                                            statusCampaignDate = true;
                                            const projectResult = await getProject(colLang, colProjectType, colCampaignDate);
                                            if(projectResult && projectResult.data.length > 0) {
                                                for(let rs of projectResult.data) {
                                                    if(rs.project_code === colProjectCode) {
                                                        url = rs.project_url;
                                                        projectId = rs.project_code;
                                                        projectSlug = rs.project_slug;
                                                        projectTypeSlug = rs.project_type_slug;
                                                        if(rs.promotions.length > 0) {
                                                            if(colCampaignId === '0638A01') {
                                                                status = 1;
                                                                break;
                                                            }
                                                            else {
                                                                for(let pr of rs.promotions) {
                                                                    campaignName = pr.campaign_name;
                                                                    if(pr.campaign_id === colCampaignId) {
                                                                        status = 1;
                                                                        break;
                                                                    }
                                                                    else {
                                                                        campaignIdArr.push(1);
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            message.push(projectResult.message);
                                                        }
                                                    }
                                                    else {
                                                        projectCodeArr.push(2);
                                                    }
                                                }
                                            }
                                            else {
                                                message.push(projectResult.message);
                                            }
                                        }

                                        if(status === 1) {
                                            projectCodeArr = [];
                                            campaignIdArr = [];
                                        }

                                        if(campaignIdArr.length > 0) {
                                            statusCampaignId = false;
                                            status = 2;
                                            message.push('Campaign ID not found');
                                        }
                                        else if(projectCodeArr.length > 0) {
                                            statusProjectCode = false;
                                            status = 2;
                                            message.push('Project Code not found');
                                        }

                                        projectCodeArr = [];
                                        campaignIdArr = [];

                                        if(status === 1) {
                                            let projectName = await Utils.getProjectNameSlug({
                                                langId: colLang,
                                                project_type_slug: projectTypeSlug,
                                                project_slug: projectSlug
                                            });

                                            projectList.push({
                                                lang: colLang,
                                                projectType: colProjectType,
                                                projectCode: colProjectCode,
                                                campaignId: colCampaignId,
                                                campaignDate: colCampaignDate,
                                                campaignName: campaignName,
                                                projectId: projectId,
                                                projectName: projectName,
                                                url: url,
                                                projectSlug: projectSlug,
                                                status: status,
                                                statusLang : statusLang,
                                                statusProjectCode : statusProjectCode,
                                                statusProjectType : statusProjectType,
                                                statusCampaignDate : statusCampaignDate,
                                                statusCampaignId : statusCampaignId,
                                                contentId: colContentId,
                                                ownerId: showOwnerId,
                                                statusContentId: statusContentId,
                                                statusOwnerId: statusOwnerId,
                                                apStatus: message.join(', '),
                                                params: paramToText(previewParams, {
                                                    contentId: colContentId,
                                                    ownerId: colOwnerId,
                                                    campaignId: colCampaignId,
                                                    campaignName: campaignName,
                                                    promotionSlug: null,
                                                    projectId: projectId,
                                                    projectName: projectName,
                                                    projectSlug: projectSlug,
                                                })
                                            });
                                        }
                                        else {
                                            projectListError.push({
                                                lang: colLang,
                                                projectType: colProjectType,
                                                projectCode: colProjectCode,
                                                campaignId: colCampaignId,
                                                campaignDate: colCampaignDate,
                                                campaignName: campaignName,
                                                projectId: projectId,
                                                projectName: '',
                                                url: url,
                                                projectSlug: projectSlug,
                                                status: status,
                                                statusLang : statusLang,
                                                statusProjectCode : statusProjectCode,
                                                statusProjectType : statusProjectType,
                                                statusCampaignDate : statusCampaignDate,
                                                statusCampaignId : statusCampaignId,
                                                contentId: colContentId,
                                                ownerId: showOwnerId,
                                                statusContentId: statusContentId,
                                                statusOwnerId: statusOwnerId,
                                                apStatus: message.join(', '),
                                                params: null
                                            });
                                        }
                                        message = [];
                                        statusAll.push(status);
                                    }
                                }
                                setUploading(false);
                                setUploaded(true);
                                setExcelProjectPreview(projectList);
                                setExcelProjectPreviewError(projectListError);
                                if(statusAll.includes(2) || statusAll.includes(0)) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }

                                toast.success("Generate Result เรียบร้อย");
                            }
                        }
                        else if(typeId.id === Utils.GENERATE_TYPE_PROMOTION) {
                            let cols = header.split(',');
                            if(cols[0] !== 'Lang') {
                                setUploading(false);
                                toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                                return;
                            }
                            else if(cols[1] !== 'BU Type') {
                                setUploading(false);
                                toast.error("Column 2 : ต้องเป็น(ชื่อ) BU Type");
                                return;
                            }
                            else if(cols[2] !== 'Campaign Type') {
                                setUploading(false);
                                toast.error("Column 3 : ต้องเป็น(ชื่อ) Campaign Type");
                                return;
                            }
                            else if(cols[3] !== 'Campaign ID') {
                                setUploading(false);
                                toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                                return;
                            }
                            else if(cols[4] !== 'Campaign Date') {
                                setUploading(false);
                                toast.error("Column 5 : ต้องเป็น(ชื่อ) Campaign Date");
                                return;
                            }
                            else if(cols[5] !== 'Content ID') {
                                setUploading(false);
                                toast.error("Column 6 : ต้องเป็น(ชื่อ) Content ID");
                                //จำเป็นต้องใส่มา ถึงจะไม่มีข้อมูลก็ตาม
                                return;
                            }
                            else if(cols[6] !== 'Owner ID') {
                                setUploading(false);
                                toast.error("Column 7 : ต้องเป็น(ชื่อ) Owner ID");
                                //จำเป็นต้องใส่มา ถึงจะไม่มีข้อมูลก็ตาม
                                return;
                            }

                            if(row.length > 0) {
                                let message = [];
                                let statusAll = [];
                                let promotionList = [];
                                let promotionListError = [];

                                let contentIdArr = [];
                                if(requireContentId) {
                                    const contentIdList = await Utils.getContentId({agencyId: roles.agencyId});
                                    for(let rs of contentIdList) {
                                        contentIdArr.push(rs.contentId);
                                    }
                                }

                                for(let i=1;i<row.length;i++) {
                                    let status = 0;
                                    let cols = row[i].split(',');
                                    let colLang = cols[0].toString().trim();
                                    let colButype = cols[1].toString().trim();
                                    let colCampaignType = cols[2].toString().trim();
                                    let colCampaignId = cols[3].toString().trim();
                                    let colCampaignDate = Utils.dateFromExcel(cols[4].toString().trim());
                                    let colContentId = cols[5].toString().trim();
                                    let colOwnerId = cols[6].toString().trim();
                                    let showOwnerId = cols[6].toString().trim();
                                    let ownerRow = null;
                                    let statusOwnerId = true;

                                    if(requireOwnerId) {
                                        if(colOwnerId) {
                                            let ow = colOwnerId.split(':');
                                            ownerRow = await Utils.getOwnerViewByCode(ow[0]);
                                            colOwnerId = 'WID:' + ownerRow.id;
                                            if(!ownerRow.id) {
                                                status = 2;
                                                statusOwnerId = false;
                                            }
                                        }
                                        else {
                                            status = 2;
                                            statusOwnerId = false;
                                        }
                                    }

                                    if(colLang && colButype && colCampaignType && colCampaignId) {
                                        let statusContentId = true;
                                        if(requireContentId) {
                                            if(contentIdArr && colContentId) {
                                                if(!contentIdArr.includes(colContentId)) {
                                                    status = 2;
                                                    statusContentId = false;
                                                }
                                                else {
                                                    statusContentId = true;
                                                }
                                            }
                                            else {
                                                status = 2;
                                                statusContentId = false;
                                            }
                                        }

                                        let statusLang = true;
                                        if(langIds && !langIds.includes(colLang)) {
                                            status = 2;
                                            statusLang = false;
                                            message.push('Invalid Lang');
                                        }
                                        else {
                                            statusLang = true;
                                        }

                                        let statusCampaignType = true;
                                        if(colCampaignType === Utils.CAMPAIGN_TYPE_ALL || colCampaignType === Utils.CAMPAIGN_TYPE_SPECIAL) {
                                            statusCampaignType = true;
                                        }
                                        else {
                                            status = 2;
                                            statusCampaignType = false;
                                            message.push('Invalid Campaign Type');
                                        }

                                        let statusBuType = true;
                                        if(colButype === 'condo' || colButype === 'condominium') {
                                            colButype = 'condo1,condo2';
                                        }
                                        if(buTypeIds && !buTypeIds.includes(colButype)) {
                                            status = 2;
                                            statusBuType = false;
                                            message.push('Invalid BU Type');
                                        }
                                        else {
                                            statusBuType = true;
                                        }

                                        let statusCampaignDate = true;
                                        let statusCampaignId = true;
                                        if(requireCampaignId && !colCampaignId) {
                                            statusCampaignId = false;
                                            status = 2;
                                        }

                                        let url = '';
                                        let promotionSlug = '';
                                        let campaignName = '';
                                        let campaignIdArr = [];

                                        if(!colCampaignDate) {
                                            status = 2;
                                            statusCampaignDate = false;
                                            message.push('Invalid campaign date');
                                        }
                                        else if(statusLang && statusBuType && statusCampaignType && statusCampaignId && statusContentId && statusOwnerId) {
                                            statusCampaignDate = true;
                                            const promotionResult = await getPromotion(colLang, colCampaignType, colButype, colCampaignDate);
                                            if(promotionResult && promotionResult.data.length > 0) {
                                                for(let rs of promotionResult.data) {
                                                    if(colCampaignId === '0638A01') {
                                                        status = 1;
                                                        break;
                                                    }
                                                    else {
                                                        if(rs.campaign_id === colCampaignId) {
                                                            url = rs.promotion_url;
                                                            promotionSlug = rs.promotion_slug;
                                                            campaignName = rs.campaign_name;
                                                            if(url) {
                                                                status = 1;
                                                                break;
                                                            }
                                                            else {
                                                                status = 2;
                                                                message.push(promotionResult.message);
                                                            }
                                                        }
                                                        else {
                                                            campaignIdArr.push(2);
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                status = 2;
                                                message.push(promotionResult.message);
                                            }
                                        }

                                        if(status === 1) {
                                            campaignIdArr = [];
                                        }

                                        if(campaignIdArr.length > 0) {
                                            statusCampaignId = false;
                                            status = 2;
                                            message.push('Campaign ID not found');
                                        }

                                        campaignIdArr = [];
                                        if(status === 1) {
                                            let promotionSlugX = await Utils.getPromotionSlug({
                                                buTypeId: colButype,
                                                campaignTypeId: colCampaignType,
                                                langId: colLang,
                                                promotionSlug: promotionSlug
                                            });

                                            promotionList.push({
                                                lang: colLang,
                                                buType: colButype,
                                                campaignType: colCampaignType,
                                                campaignId: colCampaignId,
                                                campaignDate: colCampaignDate,
                                                campaignName: campaignName,
                                                url: url,
                                                promotionSlug: promotionSlugX,
                                                status: status,
                                                statusLang : statusLang,
                                                statusBuType : statusBuType,
                                                statusCampaignType : statusCampaignType,
                                                statusCampaignDate : statusCampaignDate,
                                                statusCampaignId : statusCampaignId,
                                                contentId: colContentId,
                                                ownerId: showOwnerId,
                                                statusContentId: statusContentId,
                                                statusOwnerId: statusOwnerId,
                                                apStatus: message.join(', '),
                                                params: paramToText(previewParams, {
                                                    contentId: colContentId,
                                                    ownerId: colOwnerId,
                                                    campaignId: colCampaignId,
                                                    campaignName: campaignName,
                                                    promotionSlug: promotionSlugX,
                                                    projectId: null,
                                                    projectName: null,
                                                    projectSlug: null,
                                                })
                                            });
                                        }
                                        else {
                                            promotionListError.push({
                                                lang: colLang,
                                                buType: colButype,
                                                campaignType: colCampaignType,
                                                campaignId: colCampaignId,
                                                campaignDate: colCampaignDate,
                                                campaignName: campaignName,
                                                url: url,
                                                promotionSlug: '',
                                                status: status,
                                                statusLang : statusLang,
                                                statusBuType : statusBuType,
                                                statusCampaignType : statusCampaignType,
                                                statusCampaignDate : statusCampaignDate,
                                                statusCampaignId : statusCampaignId,
                                                contentId: colContentId,
                                                ownerId: showOwnerId,
                                                statusContentId: statusContentId,
                                                statusOwnerId: statusOwnerId,
                                                apStatus: message.join(', '),
                                                params: null
                                            });
                                        }
                                        message = [];
                                        statusAll.push(status);
                                    }
                                }
                                setUploading(false);
                                setUploaded(true);
                                setExcelPromotionPreview(promotionList);
                                setExcelPromotionPreviewError(promotionListError);
                                if(statusAll.includes(2) || statusAll.includes(0)) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }

                                toast.success("Generate Result เรียบร้อย");
                            }
                        }
                        else if(typeId.id === Utils.GENERATE_TYPE_SPECIAL) {
                            let cols = header.split(',');
                            if(cols[0] !== 'URL') {
                                setUploading(false);
                                toast.error("Column 1 : ต้องเป็น(ชื่อ) URL");
                                return;
                            }
                            else if(cols[1] !== 'Content ID') {
                                setUploading(false);
                                toast.error("Column 2 : ต้องเป็น(ชื่อ) Content ID");
                                //จำเป็นต้องใส่มา ถึงจะไม่มีข้อมูลก็ตาม
                                return;
                            }
                            else if(cols[2] !== 'Campaign ID') {
                                setUploading(false);
                                toast.error("Column 3 : ต้องเป็น(ชื่อ) Campaign ID");
                                return;
                            }
                            else if(cols[3] !== 'Owner ID') {
                                setUploading(false);
                                toast.error("Column 4 : ต้องเป็น(ชื่อ) Owner ID");
                                return;
                            }

                            if(row.length > 0) {
                                let statusAll = [];
                                let specialList = [];
                                let specialListError = [];

                                let contentIdArr = [];
                                if(requireContentId) {
                                    const contentIdList = await Utils.getContentId({agencyId: roles.agencyId});
                                    for(let rs of contentIdList) {
                                        contentIdArr.push(rs.contentId);
                                    }
                                }

                                let checkProjectIds = [];
                                let campaignIdArr = [];
                                const subCampaignList = await Utils.getListSubCampaign();
                                for(let rs of subCampaignList.campaign) {
                                    campaignIdArr.push(rs.sub_campaign_id);
                                }

                                let status = 0;
                                for(let i=1;i<row.length;i++) {
                                    let cols = row[i].split(',');
                                    let colUrl = cols[0].toString().trim();
                                    let colContentId = cols[1].toString().trim();
                                    let colCampaignId = cols[2].toString().trim();
                                    let colOwnerId = cols[3].toString().trim();
                                    let showOwnerId = cols[3].toString().trim();
                                    let ownerRow = null;
                                    let statusOwnerId = true;
                                    let statusUrl = true;

                                    if(requireOwnerId) {
                                        if(colOwnerId) {
                                            let ow = colOwnerId.split(':');
                                            ownerRow = await Utils.getOwnerViewByCode(ow[0]);
                                            colOwnerId = 'WID:' + ownerRow.id;
                                            if(!ownerRow.id) {
                                                status = 2;
                                                statusOwnerId = false;
                                            }
                                        }
                                        else {
                                            status = 2;
                                            statusOwnerId = false;
                                        }
                                    }

                                    let statusCampaignId = true;
                                    if(requireCampaignId && !colCampaignId) {
                                        statusCampaignId = false;
                                        status = 2;
                                    }

                                    if(colUrl && colCampaignId) {
                                        let statusContentId = true;
                                        let campaignName = '';

                                        if(colUrl.indexOf('http') > -1) {
                                            status = 1;
                                            statusUrl = true;
                                        }
                                        else {
                                            status = 2;
                                            statusUrl = false;
                                        }

                                        if(requireContentId) {
                                            if(contentIdArr && colContentId) {
                                                if(!contentIdArr.includes(colContentId)) {
                                                    statusContentId = false;
                                                }
                                                else {
                                                    statusContentId = true;
                                                }
                                            }
                                            else {
                                                status = 2;
                                                statusContentId = false;
                                            }
                                        }

                                        if(campaignIdArr && colCampaignId) {
                                            if(!campaignIdArr.includes(colCampaignId)) {
                                                statusCampaignId = false;
                                            }
                                            else {
                                                statusCampaignId = true;
                                                if(subCampaignList && subCampaignList.campaign && colCampaignId !== '0638A01') {
                                                    let checkCpname = subCampaignList.campaign.find(e => e.sub_campaign_id === colCampaignId);
                                                    if(checkCpname) {
                                                        campaignName = checkCpname.sub_campaign_name;
                                                    }
                                                }
                                            }
                                        }

                                        if(statusContentId && statusCampaignId && statusOwnerId && statusUrl) {
                                            status = 1;
                                        }
                                        else {
                                            status = 2;
                                        }

                                        if(previewParams) {
                                            checkProjectIds = previewParams.filter(e => e.params.includes('projectId'));
                                            if(checkProjectIds.length > 0) {
                                                status = 2;
                                                toast.error("ไม่สามารถใช้ projectId ใน Type Special ได้");
                                            }
                                        }

                                        if(status === 1) {
                                            specialList.push({
                                                url: colUrl,
                                                contentId: colContentId,
                                                ownerId: showOwnerId,
                                                campaignId: colCampaignId,
                                                campaignName: campaignName,
                                                statusContentId: statusContentId,
                                                statusCampaignId: statusCampaignId,
                                                statusOwnerId: statusOwnerId,
                                                statusUrl: statusUrl,
                                                status: status,
                                                apStatus: null,
                                                params: paramToText(previewParams, {
                                                    contentId: colContentId,
                                                    ownerId: colOwnerId,
                                                    campaignId: colCampaignId,
                                                    campaignName: campaignName
                                                })
                                            });
                                        }
                                        else {
                                            specialListError.push({
                                                url: colUrl,
                                                contentId: colContentId,
                                                ownerId: showOwnerId,
                                                campaignId: colCampaignId,
                                                campaignName: campaignName,
                                                statusContentId: statusContentId,
                                                statusCampaignId: statusCampaignId,
                                                statusOwnerId: statusOwnerId,
                                                statusUrl: statusUrl,
                                                status: status,
                                                apStatus: null,
                                                params: null
                                            });
                                        }
                                        statusAll.push(status);
                                    }
                                }

                                setUploading(false);
                                setUploaded(true);
                                setExcelSpecialPreview(specialList);
                                setExcelSpecialPreviewError(specialListError);
                                if(statusAll.includes(2) || statusAll.includes(0)) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }

                                if(checkProjectIds.length <= 0) {
                                    toast.success("Generate Result เรียบร้อย");
                                }
                            }
                        }
                        else if(typeId.id === Utils.GENERATE_TYPE_MASTER_URL) {
                            let cols = header.split(',');
                            if(cols[0] !== 'Lang') {
                                setUploading(false);
                                toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                                return;
                            }
                            else if(cols[1] !== 'Project Type') {
                                setUploading(false);
                                toast.error("Column 2 : ต้องเป็น(ชื่อ) Project Type");
                                return;
                            }
                            else if(cols[2] !== 'Project Code') {
                                setUploading(false);
                                toast.error("Column 3 : ต้องเป็น(ชื่อ) Project Code");
                                return;
                            }
                            else if(cols[3] !== 'Campaign ID') {
                                setUploading(false);
                                toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                                return;
                            }
                            else if(cols[4] !== 'Master URL') {
                                setUploading(false);
                                toast.error("Column 5 : ต้องเป็น(ชื่อ) Master URL");
                                return;
                            }
                            else if(cols[5] !== 'Content ID') {
                                setUploading(false);
                                toast.error("Column 6 : ต้องเป็น(ชื่อ) Content ID");
                                return;
                            }
                            else if(cols[6] !== 'Owner ID') {
                                setUploading(false);
                                toast.error("Column 7 : ต้องเป็น(ชื่อ) Owner ID");
                                return;
                            }

                            if(row.length > 0) {
                                let message = [];
                                let statusAll = [];
                                let projectList = [];
                                let projectListError = [];

                                let contentIdArr = [];
                                if(requireContentId) {
                                    const contentIdList = await Utils.getContentId({agencyId: roles.agencyId});
                                    for(let rs of contentIdList) {
                                        contentIdArr.push(rs.contentId);
                                    }
                                }

                                let masterURLArr = [];
                                let resMasterURL = await Utils.getMasterUrl();
                                for(let rs of resMasterURL) {
                                    masterURLArr.push(rs.url);
                                }

                                let campaignIdArr = [];
                                let campaignNameArr = [];
                                const subCampaignList = await Utils.getListSubCampaign();
                                for(let rs of subCampaignList.campaign) {
                                    campaignIdArr.push(rs.sub_campaign_id);
                                    campaignNameArr.push({
                                        id: rs.sub_campaign_id,
                                        name: rs.sub_campaign_name
                                    });
                                }

                                for(let i=1;i<row.length;i++) {
                                    let status = 0;
                                    let cols = row[i].split(',');
                                    let colLang = cols[0].toString().trim();
                                    let colProjectType = cols[1].toString().trim();
                                    let colProjectCode = cols[2].toString().trim();
                                    let colCampaignId = cols[3].toString().trim();
                                    let colMasterURL = cols[4].toString().trim();
                                    let colContentId = cols[5].toString().trim();
                                    let colOwnerId = cols[6].toString().trim();
                                    let showOwnerId = cols[6].toString().trim();
                                    let ownerRow = null;
                                    let statusOwnerId = true;
                                    let campaignName = '';
                                    let masterURLID = null;

                                    if(requireOwnerId) {
                                        if(colOwnerId) {
                                            let ow = colOwnerId.split(':');
                                            ownerRow = await Utils.getOwnerViewByCode(ow[0]);
                                            colOwnerId = 'WID:' + ownerRow.id;
                                            if(!ownerRow.id) {
                                                status = 2;
                                                statusOwnerId = false;
                                            }
                                        }
                                        else {
                                            status = 2;
                                            statusOwnerId = false;
                                        }
                                    }

                                    if(colLang && colProjectType && colProjectCode) {
                                        let statusContentId = true;
                                        if(requireContentId) {
                                            if(contentIdArr && colContentId) {
                                                if(!contentIdArr.includes(colContentId)) {
                                                    status = 2;
                                                    statusContentId = false;
                                                }
                                                else {
                                                    statusContentId = true;
                                                }
                                            }
                                            else {
                                                status = 2;
                                                statusContentId = false;
                                            }
                                        }

                                        let statusLang = true;
                                        if(langIds && !langIds.includes(colLang)) {
                                            status = 2;
                                            statusLang = false;
                                            message.push('Invalid Lang');
                                        }
                                        else {
                                            statusLang = true;
                                        }

                                        let statusProjectType = true;
                                        if(projectTypeIds && !projectTypeIds.includes(colProjectType)) {
                                            status = 2;
                                            statusProjectType = false;
                                            message.push('Invalid Project Type');
                                        }
                                        else {
                                            statusProjectType = true;
                                        }

                                        let statusProjectCode = true;
                                        if(requireProjectId && !colProjectCode) {
                                            statusProjectCode = false;
                                            status = 2;
                                        }

                                        let statusCampaignId = true;
                                        if(requireCampaignId && !colCampaignId) {
                                            statusCampaignId = false;
                                            status = 2;
                                        }

                                        let statusMasterURL = true;
                                        if(masterURLArr && !masterURLArr.includes(colMasterURL)) {
                                            status = 2;
                                            statusMasterURL = false;
                                            message.push('Master URL not found');
                                        }
                                        else {
                                            masterURLID = resMasterURL.filter(e => e.url === colMasterURL)[0].id;
                                            status = 1;
                                            statusMasterURL = true;
                                        }

                                        if(campaignIdArr && colCampaignId) {
                                            if(!campaignIdArr.includes(colCampaignId)) {
                                                status = 2;
                                                statusCampaignId = false;
                                                message.push('Campaign ID not found');
                                            }
                                            else {
                                                campaignName = campaignNameArr.filter(e => e.id === colCampaignId)[0].name;
                                                status = 1;
                                                statusCampaignId = true;
                                            }
                                        }

                                        let projectId = '';
                                        let projectSlug = '';
                                        let projectTypeSlug = '';
                                        let line_oaid = '';

                                        if(statusLang && statusProjectType && statusProjectCode && statusCampaignId && statusContentId && statusOwnerId) {
                                            const projectResult = await Utils.getProjectCode(colLang, colProjectType);
                                            if(projectResult && projectResult.data.length > 0) {
                                                let checkProjectCode = false;
                                                for(let rs of projectResult.data) {
                                                    if(rs.project_code === colProjectCode) {
                                                        projectId = rs.project_code;
                                                        projectSlug = rs.project_slug;
                                                        projectTypeSlug = rs.project_type_slug;
                                                        line_oaid = rs.line_oaid;
                                                        checkProjectCode = true;
                                                        break;
                                                    }
                                                }

                                                if(checkProjectCode) {
                                                    status = 1;
                                                    statusProjectCode = true;
                                                }
                                                else {
                                                    statusProjectCode = false;
                                                    status = 2;
                                                    message.push('Project Code not found');
                                                }
                                            }
                                            else {
                                                message.push(projectResult.message);
                                            }
                                        }

                                        if(status === 1) {
                                            let projectName = await Utils.getProjectNameSlug({
                                                langId: colLang,
                                                project_type_slug: projectTypeSlug,
                                                project_slug: projectSlug
                                            });

                                            projectList.push({
                                                lang: colLang,
                                                projectType: colProjectType,
                                                projectCode: colProjectCode,
                                                campaignId: colCampaignId,
                                                campaignName: campaignName,
                                                masterURLID: masterURLID,
                                                projectId: projectId,
                                                projectName: projectName,
                                                url: colMasterURL,
                                                projectSlug: projectSlug,
                                                line_oaid: line_oaid,
                                                status: status,
                                                statusLang : statusLang,
                                                statusProjectCode : statusProjectCode,
                                                statusProjectType : statusProjectType,
                                                statusMasterURL : statusMasterURL,
                                                statusCampaignId : statusCampaignId,
                                                contentId: colContentId,
                                                ownerId: showOwnerId,
                                                statusContentId: statusContentId,
                                                statusOwnerId: statusOwnerId,
                                                apStatus: message.join(', '),
                                                params: paramToText(previewParams, {
                                                    contentId: colContentId,
                                                    ownerId: colOwnerId,
                                                    campaignId: colCampaignId,
                                                    campaignName: campaignName,
                                                    promotionSlug: null,
                                                    projectId: projectId,
                                                    projectName: projectName,
                                                    projectSlug: projectSlug,
                                                    line_oaid: line_oaid,
                                                })
                                            });
                                        }
                                        else {
                                            projectListError.push({
                                                lang: colLang,
                                                projectType: colProjectType,
                                                projectCode: colProjectCode,
                                                campaignId: colCampaignId,
                                                campaignName: campaignName,
                                                masterURLID: masterURLID,
                                                projectId: projectId,
                                                projectName: '',
                                                url: colMasterURL,
                                                projectSlug: projectSlug,
                                                line_oaid: line_oaid,
                                                status: status,
                                                statusLang : statusLang,
                                                statusProjectCode : statusProjectCode,
                                                statusProjectType : statusProjectType,
                                                statusMasterURL : statusMasterURL,
                                                statusCampaignId : statusCampaignId,
                                                contentId: colContentId,
                                                ownerId: showOwnerId,
                                                statusContentId: statusContentId,
                                                statusOwnerId: statusOwnerId,
                                                apStatus: message.join(', '),
                                                params: null
                                            });
                                        }
                                        message = [];
                                        statusAll.push(status);
                                    }
                                }
                                setUploading(false);
                                setUploaded(true);
                                setExcelMasterURLPreview(projectList);
                                setExcelMasterURLPreviewError(projectListError);
                                if(statusAll.includes(2) || statusAll.includes(0)) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }

                                toast.success("Generate Result เรียบร้อย");
                            }
                        }
                    }
                };
                reader.readAsBinaryString(file);
            }
        }
        else {
            toast.error("กรุณาระบุ Excel File");
        }
    };

    const onGenerateUTM = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        let jsonData = [];
                        let typeName = '';
                        let bulkBody = [];
                        setImporting(true);
                        if(typeId.id === Utils.GENERATE_TYPE_PROJECT) {
                            typeName = 'Project';

                            //find last running code
                            let lastOwnerRunningCode = 1;
                            for(let rs of showExcelProjectPreview) {
                                let ownerCode = rs.ownerId;
                                if(ownerCode) {
                                    let ownerRow = await Utils.getOwnerViewByCode(ownerCode);
                                    let ownerId = ownerRow.id;
                                    for (let pm of sourceTypeAllIds) {
                                        let params = pm.params;
                                        for (let p of params) {
                                            if (p.toString().includes('x:OID')) {
                                                let ownerCodeRow = await Utils.getOwnerRunningId(ownerId);
                                                lastOwnerRunningCode = ownerCodeRow.code - 1;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }

                            let x = 1;
                            for(let rs of showExcelProjectPreview) {
                                let projectId = rs.projectId;
                                let projectName = rs.projectName;
                                let projectSlug = rs.projectSlug;
                                let lang = rs.lang;
                                let campaignId = rs.campaignId;
                                let campaignName = rs.campaignName;

                                //replace owner running code
                                let ownerId = null;
                                let ownerCode = rs.ownerId;
                                let ownerRunningCode = null;
                                if(ownerCode) {
                                    let ownerRow = await Utils.getOwnerViewByCode(ownerCode);
                                    ownerId = ownerRow.id;
                                    if(ownerId) {
                                        ownerRunningCode = Utils.getOwnerRunningCode(ownerCode, lastOwnerRunningCode + x);
                                        for(let i=0;i<rs.params.length;i++) {
                                            rs.params[i] = rs.params[i].replace('WID:' + ownerId, ownerRunningCode);
                                        }
                                        x++;
                                    }
                                }

                                let url = rs.url;
                                let utmData = [];
                                for(let pm of sourceTypeAllIds) {
                                    let params = pm.params;
                                    let id = pm.id;
                                    let name = pm.name;
                                    let utmGroupId = pm.utmGroupId;
                                    let utmTemplateId = pm.utmTemplateId;
                                    let sourceTypeIdsTmp = [];
                                    for(let p of params) {
                                        if(p.toString().includes('x:CID')) {
                                            const cRow = await Utils.getContentIdByCode(rs.contentId);
                                            p = p.replace('x', cRow.id);
                                        }
                                        if(p.toString().includes('x:OID')) {
                                            p = p.replace('x', ownerId);
                                        }
                                        if(p.toString().includes('x:CP')) {
                                            p = p.replace('x', campaignId);
                                        }
                                        if(p.toString().includes('x:CN')) {
                                            p = p.replace('x', campaignName);
                                        }
                                        else if(p.toString().includes('x:PJI')) {
                                            p = p.replace('x', projectId);
                                        }
                                        else if(p.toString().includes('x:PJN')) {
                                            p = p.replace('x', projectName);
                                        }
                                        else if(p.toString().includes('x:PJS')) {
                                            p = p.replace('x', projectSlug);
                                        }
                                        sourceTypeIdsTmp.push(p);
                                    }
                                    utmData.push({
                                        id: id,
                                        name: name,
                                        utmGroupId: utmGroupId,
                                        utmTemplateId: utmTemplateId,
                                        params: sourceTypeIdsTmp
                                    });
                                }

                                let utmParam = [];
                                let n = 0;
                                for(let data of utmData) {
                                    let params = data.params;
                                    let getParams = rs.params[n];
                                    n++;

                                    utmParam.push(getParams);
                                    getParams = getParams + (hashtag ? '#' + hashtag.name:'');
                                    data.hashtag = hashtag ? hashtag.name : null;

                                    let sourceTypeIds = [];
                                    for(let val of params) {
                                        let utmSourceTypeId = val.toString();
                                        let utmSourceId = 0;
                                        let utmSourceTypeText = null;
                                        let inputType = null;

                                        if(utmSourceTypeId.includes(':CID')) {
                                            let sp = utmSourceTypeId.split(':CID');
                                            let contentId = sp[0];
                                            utmSourceId = sp[1];
                                            let contentView = await Utils.getContentIdView(contentId);
                                            utmSourceTypeText = Utils.contentIdGenerater(contentView);
                                            utmSourceTypeId = contentId;
                                            inputType = Utils.API_TYPE_CONTENT_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':OID')) {
                                            let sp = utmSourceTypeId.split(':OID');
                                            let ownerId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = ownerRunningCode;
                                            utmSourceTypeId = ownerId;
                                            inputType = Utils.API_TYPE_OWNER_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':CP')) {
                                            let sp = utmSourceTypeId.split(':CP');
                                            let campaignId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = campaignId;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_CAMPAIGN_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':CN')) {
                                            let sp = utmSourceTypeId.split(':CN');
                                            let campaignName = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = campaignName;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                                        }
                                        else if(utmSourceTypeId.includes(':PJI')) {
                                            let sp = utmSourceTypeId.split(':PJI');
                                            let projectId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = projectId;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_PROJECT_SLUG;
                                        }
                                        else if(utmSourceTypeId.includes(':PJN')) {
                                            let sp = utmSourceTypeId.split(':PJN');
                                            let projectName = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = projectName;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_PROJECT_SLUG;
                                        }
                                        else if(utmSourceTypeId.includes(':PJS')) {
                                            let sp = utmSourceTypeId.split(':PJS');
                                            let projectSlug = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = projectSlug;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_PROJECT_SLUG;
                                        }
                                        else {
                                            for(let st of sourceTypeList) {
                                                if(parseInt(utmSourceTypeId) === st.id) {
                                                    utmSourceId = st.utmSourceId;
                                                    utmSourceTypeText = st.name;
                                                    break;
                                                }
                                            }
                                        }

                                        sourceTypeIds.push({
                                            utmSourceId: utmSourceId,
                                            utmSourceTypeId: utmSourceTypeId,
                                            utmSourceTypeText: utmSourceTypeText,
                                            inputType: inputType
                                        });
                                    }

                                    let urlParam = url + '?' + getParams;
                                    //Create Short URL (Rebrandly)
                                    let rebrandlyUrlChecked = document.getElementsByName('rebrandlyUrlChecked');
                                    let rebrandlyUrl = null;
                                    if(urlParam && rebrandlyUrlChecked[0].checked)  {
                                        const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                        rebrandlyUrl = resShortUrl.shortUrl;
                                        data.shortUrl = rebrandlyUrl;
                                    }

                                    //Create Short URL (Short.IO)
                                    let shortioUrlChecked = document.getElementsByName('shortioUrlChecked');
                                    let shortioUrl = null;
                                    if(urlParam && shortioUrlChecked.length && shortioUrlChecked[0].checked)  {
                                        const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                        shortioUrl = resShortUrl.path;
                                        data.shortIO = shortioUrl;
                                    }

                                    bulkBody.push({
                                        typeId: typeId.id,
                                        lang: lang,
                                        projectTypeId: rs.projectType,
                                        projectId: rs.projectCode,
                                        campaignDate: rs.campaignDate ? new Date(rs.campaignDate) : null,
                                        campaignId: rs.campaignId ?? null,
                                        campaignTypeId: null,
                                        buTypeId: null,
                                        promotionId: null,
                                        url: url,
                                        utmTemplateId: data.utmTemplateId ?? null,
                                        utmGroupId: data.utmGroupId ?? null,
                                        utmGroupItemId: data.id ?? null,
                                        hashtag: hashtag ? hashtag.name : null,
                                        params: getParams,
                                        shortUrl: rebrandlyUrl,
                                        shortioUrl: shortioUrl,
                                        createdBy: userId,
                                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        sourceTypeIds: sourceTypeIds
                                    });
                                }

                                jsonData.push({
                                    typeId: Utils.GENERATE_TYPE_PROJECT,
                                    row: rs,
                                    utm: utmData,
                                    params: utmParam
                                })
                            }

                            insertToDB(bulkBody, jsonData, typeName);
                        }
                        else if(typeId.id === Utils.GENERATE_TYPE_PROMOTION) {
                            typeName = 'Campaign';

                            //find last running code
                            let lastOwnerRunningCode = 1;
                            for(let rs of showExcelPromotionPreview) {
                                let ownerCode = rs.ownerId;
                                if(ownerCode) {
                                    let ownerRow = await Utils.getOwnerViewByCode(ownerCode);
                                    let ownerId = ownerRow.id;
                                    for (let pm of sourceTypeAllIds) {
                                        let params = pm.params;
                                        for (let p of params) {
                                            if (p.toString().includes('x:OID')) {
                                                let ownerCodeRow = await Utils.getOwnerRunningId(ownerId);
                                                lastOwnerRunningCode = ownerCodeRow.code - 1;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }

                            let x = 1;
                            for(let rs of showExcelPromotionPreview) {
                                let promotionSlug = rs.promotionSlug;
                                let lang = rs.lang;
                                let campaignId = rs.campaignId;
                                let campaignName = rs.campaignName;

                                //replace owner running code
                                let ownerId = null;
                                let ownerCode = rs.ownerId;
                                let ownerRunningCode = null;
                                if(ownerCode) {
                                    let ownerRow = await Utils.getOwnerViewByCode(ownerCode);
                                    ownerId = ownerRow.id;
                                    if(ownerId) {
                                        ownerRunningCode = Utils.getOwnerRunningCode(ownerCode, lastOwnerRunningCode + x);
                                        for(let i=0;i<rs.params.length;i++) {
                                            rs.params[i] = rs.params[i].replace('WID:' + ownerId, ownerRunningCode);
                                        }
                                        x++;
                                    }
                                }

                                let url = rs.url;
                                let utmData = [];
                                for(let pm of sourceTypeAllIds) {
                                    let params = pm.params;
                                    let id = pm.id;
                                    let name = pm.name;
                                    let utmGroupId = pm.utmGroupId;
                                    let utmTemplateId = pm.utmTemplateId;
                                    let sourceTypeIdsTmp = [];
                                    for(let p of params) {
                                        if(p.toString().includes('x:CID')) {
                                            const cRow = await Utils.getContentIdByCode(rs.contentId);
                                            p = p.replace('x', cRow.id);
                                        }
                                        if(p.toString().includes('x:OID')) {
                                            p = p.replace('x', ownerId);
                                        }
                                        if(p.toString().includes('x:CP')) {
                                            p = p.replace('x', campaignId);
                                        }
                                        if(p.toString().includes('x:CN')) {
                                            p = p.replace('x', campaignName);
                                        }
                                        else if(p.toString().includes('x:PMS')) {
                                            p = p.replace('x', promotionSlug);
                                        }
                                        sourceTypeIdsTmp.push(p);
                                    }
                                    utmData.push({
                                        id: id,
                                        name: name,
                                        utmGroupId: utmGroupId,
                                        utmTemplateId: utmTemplateId,
                                        params: sourceTypeIdsTmp
                                    });
                                }

                                let utmParam = [];
                                let n=0;
                                for(let data of utmData) {
                                    let params = data.params;
                                    let getParams = rs.params[n];
                                    n++;

                                    utmParam.push(getParams);
                                    getParams = getParams + (hashtag ? '#' + hashtag.name:'');
                                    data.hashtag = hashtag ? hashtag.name : null;

                                    let sourceTypeIds = [];
                                    for(let val of params) {
                                        let utmSourceTypeId = val.toString();
                                        let utmSourceId = 0;
                                        let utmSourceTypeText = null;
                                        let inputType = null;

                                        if(utmSourceTypeId.includes(':CID')) {
                                            let sp = utmSourceTypeId.split(':CID');
                                            let contentId = sp[0];
                                            utmSourceId = sp[1];
                                            let contentView = await Utils.getContentIdView(contentId);
                                            utmSourceTypeText = Utils.contentIdGenerater(contentView);
                                            utmSourceTypeId = contentId;
                                            inputType = Utils.API_TYPE_CONTENT_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':OID')) {
                                            let sp = utmSourceTypeId.split(':OID');
                                            let ownerId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = ownerRunningCode;
                                            utmSourceTypeId = ownerId;
                                            inputType = Utils.API_TYPE_OWNER_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':CP')) {
                                            let sp = utmSourceTypeId.split(':CP');
                                            let campaignId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = campaignId;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_CAMPAIGN_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':CN')) {
                                            let sp = utmSourceTypeId.split(':CN');
                                            let campaignName = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = campaignName;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                                        }
                                        else if(utmSourceTypeId.includes(':PMS')) {
                                            let sp = utmSourceTypeId.split(':PMS');
                                            let promotionSlug = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = promotionSlug;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_PROMOTION_SLUG;
                                        }
                                        else {
                                            for(let st of sourceTypeList) {
                                                if(parseInt(utmSourceTypeId) === st.id) {
                                                    utmSourceId = st.utmSourceId;
                                                    utmSourceTypeText = st.name;
                                                    break;
                                                }
                                            }
                                        }

                                        sourceTypeIds.push({
                                            utmSourceId: utmSourceId,
                                            utmSourceTypeId: utmSourceTypeId,
                                            utmSourceTypeText: utmSourceTypeText,
                                            inputType: inputType
                                        });
                                    }

                                    let urlParam = url + '?' + getParams;
                                    //Create Short URL (Rebrandly)
                                    let rebrandlyUrlChecked = document.getElementsByName('rebrandlyUrlChecked');
                                    let rebrandlyUrl = null;
                                    if(urlParam && rebrandlyUrlChecked[0].checked)  {
                                        const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                        rebrandlyUrl = resShortUrl.shortUrl;
                                        data.shortUrl = rebrandlyUrl;
                                    }

                                    //Create Short URL (Short.IO)
                                    let shortioUrlChecked = document.getElementsByName('shortioUrlChecked');
                                    let shortioUrl = null;
                                    if(urlParam && shortioUrlChecked.length && shortioUrlChecked[0].checked)  {
                                        const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                        shortioUrl = resShortUrl.path;
                                        data.shortIO = shortioUrl;
                                    }

                                    bulkBody.push({
                                        typeId: typeId.id,
                                        lang: lang,
                                        projectTypeId: rs.projectType,
                                        projectId: rs.projectCode,
                                        campaignDate: rs.campaignDate ? new Date(rs.campaignDate) : null,
                                        campaignId: rs.campaignId ?? null,
                                        campaignTypeId: rs.campaignType ?? null,
                                        buTypeId: rs.buType ?? null,
                                        promotionId: null,
                                        url: url,
                                        utmTemplateId: data.utmTemplateId ?? null,
                                        utmGroupId: data.utmGroupId ?? null,
                                        utmGroupItemId: data.id ?? null,
                                        hashtag: hashtag ? hashtag.name : null,
                                        params: getParams,
                                        shortUrl: rebrandlyUrl,
                                        shortioUrl: shortioUrl,
                                        createdBy: userId,
                                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        sourceTypeIds: sourceTypeIds
                                    });
                                }

                                jsonData.push({
                                    typeId: Utils.GENERATE_TYPE_PROMOTION,
                                    row: rs,
                                    utm: utmData,
                                    params: utmParam
                                })
                            }
                            insertToDB(bulkBody, jsonData, typeName);
                        }
                        else if(typeId.id === Utils.GENERATE_TYPE_SPECIAL) {
                            typeName = 'Special';

                            //find last running code
                            let lastOwnerRunningCode = 1;
                            for(let rs of showExcelSpecialPreview) {
                                let ownerCode = rs.ownerId;
                                if(ownerCode) {
                                    let ownerRow = await Utils.getOwnerViewByCode(ownerCode);
                                    let ownerId = ownerRow.id;
                                    for (let pm of sourceTypeAllIds) {
                                        let params = pm.params;
                                        for (let p of params) {
                                            if (p.toString().includes('x:OID')) {
                                                let ownerCodeRow = await Utils.getOwnerRunningId(ownerId);
                                                lastOwnerRunningCode = ownerCodeRow.code - 1;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }

                            let x = 1;
                            for(let rs of showExcelSpecialPreview) {
                                let lang = rs.lang;
                                let campaignId = rs.campaignId;

                                //replace owner running code
                                let ownerId = null;
                                let ownerCode = rs.ownerId;
                                let ownerRunningCode = null;
                                if(ownerCode) {
                                    let ownerRow = await Utils.getOwnerViewByCode(ownerCode);
                                    ownerId = ownerRow.id;
                                    if(ownerId) {
                                        ownerRunningCode = Utils.getOwnerRunningCode(ownerCode, lastOwnerRunningCode + x);
                                        for(let i=0;i<rs.params.length;i++) {
                                            rs.params[i] = rs.params[i].replace('WID:' + ownerId, ownerRunningCode);
                                        }
                                        x++;
                                    }
                                }

                                let url = rs.url;
                                let utmData = [];
                                for(let pm of sourceTypeAllIds) {
                                    let params = pm.params;
                                    let id = pm.id;
                                    let name = pm.name;
                                    let utmGroupId = pm.utmGroupId;
                                    let utmTemplateId = pm.utmTemplateId;
                                    let sourceTypeIdsTmp = [];
                                    for(let p of params) {
                                        if(p.toString().includes('x:CID')) {
                                            const cRow = await Utils.getContentIdByCode(rs.contentId);
                                            p = p.replace('x', cRow.id);
                                        }
                                        if(p.toString().includes('x:CP')) {
                                            p = p.replace('x', rs.campaignId);
                                        }
                                        if(p.toString().includes('x:CN')) {
                                            p = p.replace('x', rs.campaignName);
                                        }
                                        if(p.toString().includes('x:OID')) {
                                            p = p.replace('x', ownerId);
                                        }
                                        sourceTypeIdsTmp.push(p);
                                    }
                                    utmData.push({
                                        id: id,
                                        name: name,
                                        utmGroupId: utmGroupId,
                                        utmTemplateId: utmTemplateId,
                                        params: sourceTypeIdsTmp
                                    });
                                }

                                let utmParam = [];
                                let n=0;
                                for(let data of utmData) {
                                    let params = data.params;
                                    let getParams = rs.params[n];
                                    n++;

                                    utmParam.push(getParams);
                                    getParams = getParams + (hashtag ? '#' + hashtag.name:'');
                                    data.hashtag = hashtag ? hashtag.name : null;

                                    let sourceTypeIds = [];
                                    for(let val of params) {
                                        let utmSourceTypeId = val.toString();
                                        let utmSourceId = 0;
                                        let utmSourceTypeText = null;
                                        let inputType = null;

                                        if(utmSourceTypeId.includes(':CID')) {
                                            let sp = utmSourceTypeId.split(':CID');
                                            let contentId = sp[0];
                                            utmSourceId = sp[1];
                                            let contentView = await Utils.getContentIdView(contentId);
                                            utmSourceTypeText = Utils.contentIdGenerater(contentView);
                                            utmSourceTypeId = contentId;
                                            inputType = Utils.API_TYPE_CONTENT_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':OID')) {
                                            let sp = utmSourceTypeId.split(':OID');
                                            let ownerId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = ownerRunningCode;
                                            utmSourceTypeId = ownerId;
                                            inputType = Utils.API_TYPE_OWNER_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':CP')) {
                                            let sp = utmSourceTypeId.split(':CP');
                                            let campaignId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = campaignId;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_CAMPAIGN_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':CN')) {
                                            let sp = utmSourceTypeId.split(':CN');
                                            let campaignName = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = campaignName;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                                        }
                                        else {
                                            for(let st of sourceTypeList) {
                                                if(parseInt(utmSourceTypeId) === st.id) {
                                                    utmSourceId = st.utmSourceId;
                                                    utmSourceTypeText = st.name;
                                                    break;
                                                }
                                            }
                                        }

                                        sourceTypeIds.push({
                                            utmSourceId: utmSourceId,
                                            utmSourceTypeId: utmSourceTypeId,
                                            utmSourceTypeText: utmSourceTypeText,
                                            inputType: inputType
                                        });
                                    }

                                    let urlParam = url + '?' + getParams;
                                    //Create Short URL (Rebrandly)
                                    let rebrandlyUrlChecked = document.getElementsByName('rebrandlyUrlChecked');
                                    let rebrandlyUrl = null;
                                    if(urlParam && rebrandlyUrlChecked[0].checked)  {
                                        const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                        rebrandlyUrl = resShortUrl.shortUrl;
                                        data.shortUrl = rebrandlyUrl;
                                    }

                                    //Create Short URL (Short.IO)
                                    let shortioUrlChecked = document.getElementsByName('shortioUrlChecked');
                                    let shortioUrl = null;
                                    if(urlParam && shortioUrlChecked.length && shortioUrlChecked[0].checked)  {
                                        const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                        shortioUrl = resShortUrl.path;
                                        data.shortIO = shortioUrl;
                                    }

                                    bulkBody.push({
                                        typeId: typeId.id,
                                        lang: lang,
                                        projectTypeId: rs.projectType,
                                        projectId: rs.projectCode,
                                        campaignDate: rs.campaignDate ? new Date(rs.campaignDate) : null,
                                        campaignId: campaignId,
                                        campaignTypeId: null,
                                        buTypeId: null,
                                        promotionId: null,
                                        url: url,
                                        utmTemplateId: data.utmTemplateId ?? null,
                                        utmGroupId: data.utmGroupId ?? null,
                                        utmGroupItemId: data.id ?? null,
                                        hashtag: hashtag ? hashtag.name : null,
                                        params: getParams,
                                        shortUrl: rebrandlyUrl,
                                        shortioUrl: shortioUrl,
                                        createdBy: userId,
                                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        sourceTypeIds: sourceTypeIds
                                    });
                                }

                                jsonData.push({
                                    typeId: Utils.GENERATE_TYPE_SPECIAL,
                                    row: rs,
                                    utm: utmData,
                                    params: utmParam
                                })
                            }

                            insertToDB(bulkBody, jsonData, typeName);
                        }
                        else if(typeId.id === Utils.GENERATE_TYPE_MASTER_URL) {
                            typeName = 'MasterURL';

                            //find last running code
                            let lastOwnerRunningCode = 1;
                            for(let rs of showExcelMasterURLPreview) {
                                let ownerCode = rs.ownerId;
                                if(ownerCode) {
                                    let ownerRow = await Utils.getOwnerViewByCode(ownerCode);
                                    let ownerId = ownerRow.id;
                                    for (let pm of sourceTypeAllIds) {
                                        let params = pm.params;
                                        for (let p of params) {
                                            if (p.toString().includes('x:OID')) {
                                                let ownerCodeRow = await Utils.getOwnerRunningId(ownerId);
                                                lastOwnerRunningCode = ownerCodeRow.code - 1;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }

                            let x = 1;
                            for(let rs of showExcelMasterURLPreview) {
                                let projectId = rs.projectId;
                                let projectName = rs.projectName;
                                let projectSlug = rs.projectSlug;
                                let lang = rs.lang;
                                let campaignId = rs.campaignId;
                                let campaignName = rs.campaignName;
                                let masterURLID = rs.masterURLID;
                                let line_oaid = rs.line_oaid;

                                //replace owner running code
                                let ownerId = null;
                                let ownerCode = rs.ownerId;
                                let ownerRunningCode = null;
                                if(ownerCode) {
                                    let ownerRow = await Utils.getOwnerViewByCode(ownerCode);
                                    ownerId = ownerRow.id;
                                    if(ownerId) {
                                        ownerRunningCode = Utils.getOwnerRunningCode(ownerCode, lastOwnerRunningCode + x);
                                        for(let i=0;i<rs.params.length;i++) {
                                            rs.params[i] = rs.params[i].replace('WID:' + ownerId, ownerRunningCode);
                                        }
                                        x++;
                                    }
                                }

                                let url = rs.url;
                                let utmData = [];
                                for(let pm of sourceTypeAllIds) {
                                    let params = pm.params;
                                    let id = pm.id;
                                    let name = pm.name;
                                    let utmGroupId = pm.utmGroupId;
                                    let utmTemplateId = pm.utmTemplateId;
                                    let sourceTypeIdsTmp = [];
                                    for(let p of params) {
                                        if(p.toString().includes('x:CID')) {
                                            const cRow = await Utils.getContentIdByCode(rs.contentId);
                                            p = p.replace('x', cRow.id);
                                        }
                                        if(p.toString().includes('x:OID')) {
                                            p = p.replace('x', ownerId);
                                        }
                                        if(p.toString().includes('x:CP')) {
                                            p = p.replace('x', campaignId);
                                        }
                                        if(p.toString().includes('x:CN')) {
                                            p = p.replace('x', campaignName);
                                        }
                                        else if(p.toString().includes('x:PJI')) {
                                            p = p.replace('x', projectId);
                                        }
                                        else if(p.toString().includes('x:PJN')) {
                                            p = p.replace('x', projectName);
                                        }
                                        else if(p.toString().includes('x:PJS')) {
                                            p = p.replace('x', projectSlug);
                                        }
                                        else if(p.toString().includes('x:LINEOA')) {
                                            p = p.replace('x', line_oaid);
                                        }
                                        sourceTypeIdsTmp.push(p);
                                    }
                                    utmData.push({
                                        id: id,
                                        name: name,
                                        utmGroupId: utmGroupId,
                                        utmTemplateId: utmTemplateId,
                                        params: sourceTypeIdsTmp
                                    });
                                }

                                let utmParam = [];
                                let n = 0;
                                for(let data of utmData) {
                                    let params = data.params;
                                    let getParams = rs.params[n];
                                    n++;

                                    utmParam.push(getParams);
                                    getParams = getParams + (hashtag ? '#' + hashtag.name:'');
                                    data.hashtag = hashtag ? hashtag.name : null;

                                    let sourceTypeIds = [];
                                    for(let val of params) {
                                        let utmSourceTypeId = val.toString();
                                        let utmSourceId = 0;
                                        let utmSourceTypeText = null;
                                        let inputType = null;

                                        if(utmSourceTypeId.includes(':CID')) {
                                            let sp = utmSourceTypeId.split(':CID');
                                            let contentId = sp[0];
                                            utmSourceId = sp[1];
                                            let contentView = await Utils.getContentIdView(contentId);
                                            utmSourceTypeText = Utils.contentIdGenerater(contentView);
                                            utmSourceTypeId = contentId;
                                            inputType = Utils.API_TYPE_CONTENT_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':OID')) {
                                            let sp = utmSourceTypeId.split(':OID');
                                            let ownerId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = ownerRunningCode;
                                            utmSourceTypeId = ownerId;
                                            inputType = Utils.API_TYPE_OWNER_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':CP')) {
                                            let sp = utmSourceTypeId.split(':CP');
                                            let campaignId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = campaignId;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_CAMPAIGN_ID;
                                        }
                                        else if(utmSourceTypeId.includes(':CN')) {
                                            let sp = utmSourceTypeId.split(':CN');
                                            let campaignName = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = campaignName;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                                        }
                                        else if(utmSourceTypeId.includes(':PJI')) {
                                            let sp = utmSourceTypeId.split(':PJI');
                                            let projectId = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = projectId;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_PROJECT_SLUG;
                                        }
                                        else if(utmSourceTypeId.includes(':PJN')) {
                                            let sp = utmSourceTypeId.split(':PJN');
                                            let projectName = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = projectName;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_PROJECT_SLUG;
                                        }
                                        else if(utmSourceTypeId.includes(':PJS')) {
                                            let sp = utmSourceTypeId.split(':PJS');
                                            let projectSlug = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = projectSlug;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_PROJECT_SLUG;
                                        }
                                        else if(utmSourceTypeId.includes(':LINEOA')) {
                                            let sp = utmSourceTypeId.split(':LINEOA');
                                            let line_oaid = sp[0];
                                            utmSourceId = sp[1];
                                            utmSourceTypeText = line_oaid;
                                            utmSourceTypeId = 0;
                                            inputType = Utils.API_TYPE_LINE_OAID;
                                        }
                                        else {
                                            for(let st of sourceTypeList) {
                                                if(parseInt(utmSourceTypeId) === st.id) {
                                                    utmSourceId = st.utmSourceId;
                                                    utmSourceTypeText = st.name;
                                                    break;
                                                }
                                            }
                                        }

                                        sourceTypeIds.push({
                                            utmSourceId: utmSourceId,
                                            utmSourceTypeId: utmSourceTypeId,
                                            utmSourceTypeText: utmSourceTypeText,
                                            inputType: inputType
                                        });
                                    }

                                    let urlParam = url + '?' + getParams;
                                    //Create Short URL (Rebrandly)
                                    let rebrandlyUrlChecked = document.getElementsByName('rebrandlyUrlChecked');
                                    let rebrandlyUrl = null;
                                    if(urlParam && rebrandlyUrlChecked[0].checked)  {
                                        const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                        rebrandlyUrl = resShortUrl.shortUrl;
                                        data.shortUrl = rebrandlyUrl;
                                    }

                                    //Create Short URL (Short.IO)
                                    let shortioUrlChecked = document.getElementsByName('shortioUrlChecked');
                                    let shortioUrl = null;
                                    if(urlParam && shortioUrlChecked.length && shortioUrlChecked[0].checked)  {
                                        const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                        shortioUrl = resShortUrl.path;
                                        data.shortIO = shortioUrl;
                                    }

                                    bulkBody.push({
                                        typeId: typeId.id,
                                        lang: lang,
                                        projectTypeId: rs.projectType,
                                        projectId: rs.projectCode,
                                        campaignDate: rs.campaignDate ? new Date(rs.campaignDate) : null,
                                        campaignId: rs.campaignId ?? null,
                                        campaignTypeId: null,
                                        buTypeId: null,
                                        promotionId: null,
                                        url: url,
                                        masterUrlId: masterURLID,
                                        utmTemplateId: data.utmTemplateId ?? null,
                                        utmGroupId: data.utmGroupId ?? null,
                                        utmGroupItemId: data.id ?? null,
                                        hashtag: hashtag ? hashtag.name : null,
                                        params: getParams,
                                        shortUrl: rebrandlyUrl,
                                        shortioUrl: shortioUrl,
                                        createdBy: userId,
                                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        sourceTypeIds: sourceTypeIds
                                    });
                                }

                                jsonData.push({
                                    typeId: Utils.GENERATE_TYPE_MASTER_URL,
                                    row: rs,
                                    utm: utmData,
                                    params: utmParam
                                })
                            }

                            insertToDB(bulkBody, jsonData, typeName);
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    const insertToDB = (body, jsonData, typeName) => {
        fetch(Config.url.API_URL +'/api/utmGenerate/createBulks', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type':'application/json',
                'x-access-token': roles.accessToken
            }
        }).then(response => {
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            if(result) {
                if(jsonData) {
                    let newJsonData = [];
                    if(jsonData[0].typeId === Utils.GENERATE_TYPE_PROJECT) {
                        let jsonLength = jsonData.length;
                        for(let i=0;i<jsonLength;i++) {
                            let url = jsonData[i].row.url;
                            url = url.toString().trim();
                            let item = [];
                            item['Lang'] = jsonData[i].row.lang;
                            item['ProjectType'] = jsonData[i].row.projectType;
                            item['ProjectCode'] = jsonData[i].row.projectCode;
                            item['CampaignID'] = jsonData[i].row.campaignId;
                            item['CampaignDate'] = jsonData[i].row.campaignDate;
                            item['ContentID'] = jsonData[i].row.contentId;
                            item['OwnerId'] = jsonData[i].row.ownerId;
                            item['URL'] = url;

                            let utm = jsonData[i].utm;
                            let utmLength = utm.length;
                            for(let j=0;j<utmLength;j++) {
                                let params = jsonData[i].params;
                                item[utm[j].name] = url + '?' + params[j] + (utm[j].hashtag ? '#' + utm[j].hashtag:'');
                                if(utm[j].shortUrl) {
                                    item['ShortURL('+utm[j].name+')'] = utm[j].shortUrl;
                                }
                                if(utm[j].shortIO) {
                                    item['ShortIO('+utm[j].name+')'] = shortio.domain + '/' + utm[j].shortIO;
                                }
                            }
                            newJsonData.push(item);
                        }
                    }
                    if(jsonData[0].typeId === Utils.GENERATE_TYPE_PROMOTION) {
                        let jsonLength = jsonData.length;
                        for(let i=0;i<jsonLength;i++) {
                            let url = jsonData[i].row.url;
                            url = url.toString().trim();
                            let item = [];
                            item['Lang'] = jsonData[i].row.lang;
                            item['BUType'] = jsonData[i].row.buType;
                            item['CampaignType'] = jsonData[i].row.campaignType;
                            item['CampaignID'] = jsonData[i].row.campaignId;
                            item['CampaignDate'] = jsonData[i].row.campaignDate;
                            item['ContentID'] = jsonData[i].row.contentId;
                            item['OwnerId'] = jsonData[i].row.ownerId;
                            item['URL'] = url;

                            let utm = jsonData[i].utm;
                            let utmLength = utm.length;
                            for(let j=0;j<utmLength;j++) {
                                let params = jsonData[i].params;
                                item[utm[j].name] = url + '?' + params[j] + (utm[j].hashtag ? '#' + utm[j].hashtag:'');
                                if(utm[j].shortUrl) {
                                    item['ShortURL('+utm[j].name+')'] = utm[j].shortUrl;
                                }
                                if(utm[j].shortIO) {
                                    item['ShortIO('+utm[j].name+')'] = shortio.domain + '/' + utm[j].shortIO;
                                }
                            }
                            newJsonData.push(item);
                        }
                    }
                    if(jsonData[0].typeId === Utils.GENERATE_TYPE_SPECIAL) {
                        let jsonLength = jsonData.length;
                        for(let i=0;i<jsonLength;i++) {
                            let url = jsonData[i].row.url;
                            url = url.toString().trim();
                            let item = [];
                            item['CampaignID'] = jsonData[i].row.campaignId;
                            item['Content ID'] = jsonData[i].row.contentId;
                            item['Owner ID'] = jsonData[i].row.ownerId;
                            item['URL'] = url;

                            let utm = jsonData[i].utm;
                            let utmLength = utm.length;
                            for(let j=0;j<utmLength;j++) {
                                let params = jsonData[i].params;
                                item[utm[j].name] = url + '?' + params[j] + (utm[j].hashtag ? '#' + utm[j].hashtag:'');
                                if(utm[j].shortUrl) {
                                    item['ShortURL('+utm[j].name+')'] = utm[j].shortUrl;
                                }
                                if(utm[j].shortIO) {
                                    item['ShortIO('+utm[j].name+')'] = shortio.domain + '/' + utm[j].shortIO;
                                }
                            }
                            newJsonData.push(item);
                        }
                    }
                    if(jsonData[0].typeId === Utils.GENERATE_TYPE_MASTER_URL) {
                        let jsonLength = jsonData.length;
                        for(let i=0;i<jsonLength;i++) {
                            let url = jsonData[i].row.url;
                            url = url.toString().trim();
                            let item = [];
                            item['Lang'] = jsonData[i].row.lang;
                            item['ProjectType'] = jsonData[i].row.projectType;
                            item['ProjectCode'] = jsonData[i].row.projectCode;
                            item['CampaignID'] = jsonData[i].row.campaignId;
                            item['MasterURL'] = jsonData[i].row.url;
                            item['ContentID'] = jsonData[i].row.contentId;
                            item['OwnerId'] = jsonData[i].row.ownerId;
                            item['URL'] = url;

                            let utm = jsonData[i].utm;
                            let utmLength = utm.length;
                            for(let j=0;j<utmLength;j++) {
                                let params = jsonData[i].params;
                                item[utm[j].name] = url + '?' + params[j] + (utm[j].hashtag ? '#' + utm[j].hashtag:'');
                                if(utm[j].shortUrl) {
                                    item['ShortURL('+utm[j].name+')'] = utm[j].shortUrl;
                                }
                                if(utm[j].shortIO) {
                                    item['ShortIO('+utm[j].name+')'] = shortio.domain + '/' + utm[j].shortIO;
                                }
                            }
                            newJsonData.push(item);
                        }
                    }
                    const worksheet = XLSX.utils.json_to_sheet(newJsonData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "UTMData_" + typeName + "_" + Utils.getDate() + ".xlsx");
                }

                toast.success("บันทึกข้อมูลเรียบร้อย");
                setTimeout(function () {
                    window.location = '/utmGenerate';
                    //navigate('/utmGenerate', {replace: true});
                }, 1000);
            }
            else {
                setImporting(false);
            }
        }).catch(err => {
            toast.error(err.message);
        })
    };

    const resetUpload = () => {
        window.location.reload();
    };

    const paramToText = (params, data) => {
        let result = [];
        for(let rs of params) {
            let param = rs.params;
            let ownerId = data.ownerId;
            let contentId = data.contentId;
            let campaignId = data.campaignId;
            let campaignName = data.campaignName;
            let promotionSlug = data.promotionSlug;
            let projectId = data.projectId;
            let projectName = data.projectName;
            let projectSlug = data.projectSlug;
            let line_oaid = data.line_oaid;
            let newParam = param.toString();
            newParam = newParam.replace('{ownerId}', ownerId);
            newParam = newParam.replace('{contentId}', contentId);
            newParam = newParam.replace('{campaignId}', campaignId);
            newParam = newParam.replace('{campaignName}', campaignName);
            newParam = newParam.replace('{promotionSlug}', promotionSlug);
            newParam = newParam.replace('{projectId}', projectId);
            newParam = newParam.replace('{projectName}', projectName);
            newParam = newParam.replace('{projectSlug}', projectSlug);
            newParam = newParam.replace('{lineOAUrl}', line_oaid);
            result.push(newParam);
        }
        return result;
    };

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate UTM Multiple</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    <NavLink className="btn btn-sm btn-light me-2" to='/utmGenerate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <h6><Icon.Upload size={16} /> Export Empty Template</h6>
                    <div className="col-12">
                        <form className="row g-3">
                            <div className="col-12 col-md-8">
                                <label htmlFor="typeIed" className="form-label">Type <span className="text-danger">*</span></label>
                                <div className="row">
                                    <div className="col-6">
                                        <Select
                                            isClearable={true}
                                            classNamePrefix="form-select-search"
                                            options={type}
                                            onChange={(event) => onChangeTypeId(event)}
                                            value={typeId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <button type="button" className="btn btn-success" onClick={onDownload}><span
                                            className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span>{isLoading ? btnTextLoading : btnTextDefault}</button>

                                        <a href="https://drive.google.com/drive/folders/1wF9-2YAHtXs7CALrA_3gGsXPyBBM_LnZ" target="_blank" className="btn btn-warning ms-2">คู่มือการใช้งาน</a>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* ----- UPLOAD ----- */}
            <div className="rounded bg-white p-4 shadow mt-3">
                <div className="row">
                    <h6><Icon.Download size={16} /> Import Template Data</h6>
                    <div className="col-12">
                        <form className="row g-3">
                            <div className="col-12 col-md-6">
                                <label htmlFor="group" className="form-label">Group UTM <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={utmGroup}
                                    onChange={(event) => onChangeUtmGroupId(event)}
                                    value={utmGroupId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>

                            <div className="col-12 mt-3 p-2">
                                <div className="fw-bold py-2 ps-2 bg-yellow-light">Group URL</div>
                                <div className={"mt-2 spinner-grow spinner-grow-sm" + (isPreviewing ? '':' d-none')}></div>
                                <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                                    <table className={"table table-bordered table-yellow" + (isPreviewing ? ' d-none':'')}>
                                        <thead>
                                        <tr>
                                            <th width="150">Name</th>
                                            <th>Format</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            previewParams.length ?
                                                previewParams.map((row, index) => {
                                                    return (<tr key={index}><td>{row.name}</td><td>{row.params}</td></tr>)
                                                }) : null
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="col-12 col-md-8">
                                <label htmlFor="excelFilex" className="form-label">Excel File <span className="text-danger">*</span></label>
                                <div className="row">
                                    <div className={"col-8 " + (isUploaded ? 'd-none':'d-block')}>
                                        <div className="input-group mb-3">
                                            <input type="file" className="form-control" id="excelFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => {onSelectFile(e)}} />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <button type="button" className={"btn btn-primary " + (isUploaded ? 'd-none':'d-block')} onClick={onUpload} disabled={isUploading}><span
                                            className={isUploading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isUploading ? btnTextUploading : btnTextUploadDefault}</button>
                                        <button type="button" className={"btn btn-secondary " + (!isUploaded ? 'd-none':'d-block')} onClick={resetUpload}>เริ่มใหม่</button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="fw-bold py-2 ps-2 bg-green-light">Generate Result</div>
                                <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                                    <table className={"table table-bordered table-green" + (showExcelProjectPreview && typeId && typeId.id === Utils.GENERATE_TYPE_PROJECT ? '':' d-none')}>
                                        <thead>
                                            <tr>
                                                <th className="text-center" width="60">Lang <span className="text-danger">*</span></th>
                                                <th width="100" className="text-center">Project Type <span className="text-danger">*</span></th>
                                                <th width="120" className="text-center">Project Code <span className="text-danger">*</span></th>
                                                <th width="100" className="text-center">Campaign ID</th>
                                                <th width="120" className="text-center">Campaign Date</th>
                                                <th>URL</th>
                                                <th>Project Slug</th>
                                                <th width="100" className="text-center">Content ID</th>
                                                <th width="100" className="text-center">Owner ID</th>
                                                <th className="text-center" width="60">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            showExcelProjectPreviewError.length ?
                                                showExcelProjectPreviewError.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusProjectType ? ' text-danger':'')}>{row.projectType}</td>
                                                        <td className={"text-center" + (!row.statusProjectCode ? ' text-danger':'')}>{row.projectCode}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId}</td>
                                                        <td className={"text-center" + (!row.statusCampaignDate ? ' text-danger':'')}>{row.campaignDate}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className="text-center">{row.projectSlug}</td>
                                                        <td className={"text-center" + (!row.statusContentId ? ' text-danger':'')}>{row.contentId ? row.contentId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center" + (!row.statusOwnerId ? ' text-danger':'')}>{row.ownerId ? row.ownerId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        {
                                            showExcelProjectPreview.length ?
                                                showExcelProjectPreview.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusProjectType ? ' text-danger':'')}>{row.projectType}</td>
                                                        <td className={"text-center" + (!row.statusProjectCode ? ' text-danger':'')}>{row.projectCode}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId ? row.campaignId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center" + (!row.statusCampaignDate ? ' text-danger':'')}>{row.campaignDate}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className="text-center">{row.projectSlug}</td>
                                                        <td className={"text-center" + (!row.statusContentId ? ' text-danger':'')}>{row.contentId}</td>
                                                        <td className={"text-center" + (!row.statusOwnerId ? ' text-danger':'')}>{row.ownerId}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        </tbody>
                                    </table>

                                    <table className={"table table-bordered table-green" + (showExcelPromotionPreview && typeId && typeId.id === Utils.GENERATE_TYPE_PROMOTION ? '':' d-none')}>
                                        <thead>
                                        <tr>
                                            <th className="text-center" width="60">Lang <span className="text-danger">*</span></th>
                                            <th className="text-center" width="100">BU Type <span className="text-danger">*</span></th>
                                            <th className="text-center" width="120">Campaign Type <span className="text-danger">*</span></th>
                                            <th className="text-center" width="100">Campaign ID <span className="text-danger">*</span></th>
                                            <th className="text-center" width="110">Campaign Date</th>
                                            <th>URL</th>
                                            <th>Promotion Slug</th>
                                            <th width="100" className="text-center">Content ID</th>
                                            <th width="100" className="text-center">Owner ID</th>
                                            <th className="text-center" width="60">Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            showExcelPromotionPreviewError.length ?
                                                showExcelPromotionPreviewError.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusBuType ? ' text-danger':'')}>{row.buType}</td>
                                                        <td className={"text-center" + (!row.statusCampaignType ? ' text-danger':'')}>{row.campaignType}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId ? row.campaignId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center" + (!row.statusCampaignDate ? ' text-danger':'')}>{row.campaignDate}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className="text-center">{row.promotionSlug}</td>
                                                        <td className={"text-center" + (!row.statusContentId ? ' text-danger':'')}>{row.contentId ? row.contentId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center" + (!row.statusOwnerId ? ' text-danger':'')}>{row.ownerId ? row.ownerId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        {
                                            showExcelPromotionPreview.length ?
                                                showExcelPromotionPreview.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusBuType ? ' text-danger':'')}>{row.buType}</td>
                                                        <td className={"text-center" + (!row.statusCampaignType ? ' text-danger':'')}>{row.campaignType}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId}</td>
                                                        <td className={"text-center" + (!row.statusCampaignDate ? ' text-danger':'')}>{row.campaignDate}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className="text-center">{row.promotionSlug}</td>
                                                        <td className={"text-center" + (!row.statusContentId ? ' text-danger':'')}>{row.contentId}</td>
                                                        <td className={"text-center" + (!row.statusOwnerId ? ' text-danger':'')}>{row.ownerId}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        </tbody>
                                    </table>

                                    <table className={"table table-bordered table-green" + (showExcelSpecialPreview && typeId && typeId.id === Utils.GENERATE_TYPE_SPECIAL ? '':' d-none')}>
                                        <thead>
                                        <tr>
                                            <th>URL <span className="text-danger">*</span></th>
                                            <th width="100" className="text-center">Content ID</th>
                                            <th width="100" className="text-center">Campaign ID</th>
                                            <th className="text-center">Campaign Name</th>
                                            <th width="100" className="text-center">Owner ID</th>
                                            <th className="text-center" width="60">Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            showExcelSpecialPreviewError.length ?
                                                showExcelSpecialPreviewError.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"" + (!row.statusUrl ? ' text-danger':'')}>{row.url}{!row.statusUrl ? <p>กรุณาระบุ http:// หรือ https://</p>:''}</td>
                                                        <td className={"text-center" + (!row.statusContentId ? ' text-danger':'')}>{row.contentId ? row.contentId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId ? row.campaignId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center small" + (!row.statusCampaignId ? ' text-danger':'')}><textarea className="w-100" disabled={true} rows={2} defaultValue={row.campaignName}></textarea></td>
                                                        <td className={"text-center" + (!row.statusOwnerId ? ' text-danger':'')}>{row.ownerId ? row.ownerId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        {
                                            showExcelSpecialPreview.length ?
                                                showExcelSpecialPreview.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td>{row.url}</td>
                                                        <td className="text-center">{row.contentId}</td>
                                                        <td className="text-center">{row.campaignId}</td>
                                                        <td className={"text-center small" + (!row.statusCampaignId ? ' text-danger':'')}><textarea className="w-100" disabled={true} rows={2} defaultValue={row.campaignName}></textarea></td>
                                                        <td className={"text-center" + (!row.statusOwnerId ? ' text-danger':'')}>{row.ownerId}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        </tbody>
                                    </table>

                                    <table className={"table table-bordered table-green" + (showExcelMasterURLPreview && typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL ? '':' d-none')}>
                                        <thead>
                                        <tr>
                                            <th className="text-center" width="60">Lang <span className="text-danger">*</span></th>
                                            <th width="100" className="text-center">Project Type <span className="text-danger">*</span></th>
                                            <th width="120" className="text-center">Project Code <span className="text-danger">*</span></th>
                                            <th width="100" className="text-center">Campaign ID</th>
                                            <th>Master URL</th>
                                            <th width="100" className="text-center">Content ID</th>
                                            <th width="100" className="text-center">Owner ID</th>
                                            <th className="text-center" width="60">Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            showExcelMasterURLPreviewError.length ?
                                                showExcelMasterURLPreviewError.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusProjectType ? ' text-danger':'')}>{row.projectType}</td>
                                                        <td className={"text-center" + (!row.statusProjectCode ? ' text-danger':'')}>{row.projectCode}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className={"text-center" + (!row.statusContentId ? ' text-danger':'')}>{row.contentId ? row.contentId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center" + (!row.statusOwnerId ? ' text-danger':'')}>{row.ownerId ? row.ownerId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        {
                                            showExcelMasterURLPreview.length ?
                                                showExcelMasterURLPreview.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusProjectType ? ' text-danger':'')}>{row.projectType}</td>
                                                        <td className={"text-center" + (!row.statusProjectCode ? ' text-danger':'')}>{row.projectCode}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId ? row.campaignId : 'กรุณาระบุ'}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className={"text-center" + (!row.statusContentId ? ' text-danger':'')}>{row.contentId}</td>
                                                        <td className={"text-center" + (!row.statusOwnerId ? ' text-danger':'')}>{row.ownerId}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mt-3">
                                    <div className="row">
                                        <div className={"col-12" + (disableImport ? ' d-none':'')}>
                                            <label htmlFor="typeIed" className="form-label">Hashtag (#)</label>
                                            <Select
                                                isClearable={true}
                                                classNamePrefix="form-select-search"
                                                options={hashtagList}
                                                onChange={(event) => onChangeHashtag(event)}
                                                getOptionValue={(option) => `${option.name}`}
                                                getOptionLabel={(option) => `${option.name}`}
                                            />
                                        </div>
                                        <div className={"col-12 mt-3" + (disableImport ? ' d-none':'') + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && rebrandly && rebrandly.status===1 && rebrandly.apiKey && rebrandly.endpoint ? '':' d-none')}>
                                            <label htmlFor="rebrandlyUrlx" className="form-label">Create Short URL (Rebrandly)</label>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" name="rebrandlyUrlChecked" id="rebrandlyUrl" defaultChecked={false} />
                                                <label className="form-check-label" htmlFor="rebrandlyUrl"></label>
                                            </div>
                                        </div>
                                        <div className={"col-12 mt-3" + (disableImport ? ' d-none':'') + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && shortio && shortio.status===1 && shortio.apiKey && shortio.endpoint ? '':' d-none')}>
                                            <label htmlFor="shortioUrlx" className="form-label">Create Short URL (Short.IO)</label>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" name="shortioUrlChecked" id="shortioUrl" defaultChecked={false} />
                                                <label className="form-check-label" htmlFor="shortioUrl"></label>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="button" className={"btn btn-success mt-3 " + (disableImport ? ' d-none':'')} onClick={onGenerateUTM} disabled={isImporting}><span
                                        className={isImporting ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> <Icon.CloudArrowUp siize={16} /> {isImporting ? btnTextImporting : btnTextImportDefault}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
}